import { render, staticRenderFns } from "./cabinet-side.vue?vue&type=template&id=3db6175e&scoped=true"
import script from "./cabinet-side.vue?vue&type=script&lang=ts"
export * from "./cabinet-side.vue?vue&type=script&lang=ts"
import style0 from "./cabinet-side.vue?vue&type=style&index=0&id=3db6175e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db6175e",
  null
  
)

export default component.exports